import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface DistributionProject {
    _id: string;
    project_name: string;
    brand_name: string;
    location_name: string;
    application_name: string;
    design_name: string;
    category: string;
    diameter: string;
    diameter_unit: string;
    p_height: string;
    p_height_unit: string;
    s_design: string;
    s_length: string;
    s_length_unit: string;
    s_width: string;
    s_width_unit: string;
    s_height: string;
    s_height_unit: string;
    createdAt: string;
    createdBy: string;
}

export type DistributionResponse = DistributionProject[];

export const distributionApiSlice = createApi({
    reducerPath: 'distributionApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://distributionanalytics.azurewebsites.net/api',
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json');
            headers.set('Accept', 'application/json');
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getDistributionProjects: builder.query<DistributionResponse, void>({
            query: () => ({
                url: '/requestItem/list',
                method: 'GET',
                credentials: 'omit',
                mode: 'cors',
            }),
        }),
    }),
});

export const { useGetDistributionProjectsQuery } = distributionApiSlice; 